import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/jukeTreasureApi'

class Store {
  @observable list = []
  @observable total = 1
  @observable loading = false
  @observable
  pagination = {
    current: 1,
    pageSize: 20,
    total: 1
  }
  @action
  getList = async page => {
    const { pagination } = this
    this.loading = true
    let params = {
      per_page: 20,
      page: page ? page : pagination.current
    }
    let {
      data: { list, total_count }
    } = await Api.record(params)
    runInAction(() => {
      this.list = list
      this.pagination.total = +total_count
      this.loading = false
    })
  }

  @action
  setPage = page => {
    this.pagination.current = page.current
    this.getList(page.current)
  }
}
export default new Store()
